/**
 * Summary Card Component
 * Displays key financial metrics
 */

import React from 'react';
import './SummaryCard.css';

const SummaryCard = ({ title, value, subtitle, icon, color = 'default', onClick, selected = false }) => {
  const formatValue = (val) => {
    if (typeof val === 'number') {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
      }).format(Math.abs(val));
    }
    return val;
  };

  return (
    <button
      type="button"
      className={`summary-card summary-card-${color} ${selected ? 'summary-card-selected' : ''} ${onClick ? 'summary-card-clickable' : ''}`}
      onClick={onClick}
      aria-pressed={selected}
    >
      <div className="card-header">
        {icon && <span className="card-icon">{icon}</span>}
        <h3 className="card-title">{title}</h3>
      </div>
      <div className="card-content">
        <p className="card-value">{formatValue(value)}</p>
        {subtitle && <p className="card-subtitle">{subtitle}</p>}
      </div>
    </button>
  );
};

export default SummaryCard;
